import { Button, Center, Heading, Input, Text } from "@chakra-ui/react"
import { faCancel, faUpload } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"
import AudioPlayer from "./audioPlayer"
import { v4 } from "uuid"
import { MediaMeta, MediaType } from "@/pages/mediaManager"

const AudioChecker: React.FC<{
	currentAudio: File,
	onAdd: (newMedia: MediaMeta, file: File, icon?: File) => void,
	onValidate: (newMedia: MediaMeta) => string | undefined
}> = ({ currentAudio, onAdd, onValidate }) => {
	const [invalid, setInvalid] = useState<string>()

	function createMedia() {
		const id = v4()
		return {
			id: `${id}${currentAudio.name.slice(currentAudio.name.lastIndexOf('.'))}`,
			iconId: `${id}.png`,
			name: currentAudio.name.slice(0, currentAudio.name.lastIndexOf('.')),
			type: MediaType.Audio,
			uploaded: new Date(),
			references: [],
			fileUrl: URL.createObjectURL(currentAudio),
			size: currentAudio.size
		}
	}
	const [newMedia, setNewMedia] = useState<MediaMeta>(createMedia())

	useEffect(() => {
		setNewMedia(createMedia())
	}, [currentAudio])

	useEffect(() => {
		setInvalid(onValidate(newMedia))
	}, [currentAudio])

	return (
		<Center flexDir='column' gap={3} paddingY={3}>
			<Heading>Play Audio</Heading>
			<AudioPlayer audioUrl={URL.createObjectURL(currentAudio)} />
			<Center gap={3} paddingY={3}>
				<Text as='b' w={195}> Item Name: </Text>
				<Input
					placeholder="Item Name"
					value={newMedia.name}
					onChange={(e) => setNewMedia({ ...newMedia, name: e.target.value })}
				/>
			</Center>
			<Center paddingY={3} gap={3} w='100%'>
				{invalid ? (
					<Button leftIcon={<FontAwesomeIcon icon={faCancel} />} flex={1} isDisabled>{invalid}</Button>
				) : (
					<Button leftIcon={<FontAwesomeIcon icon={faUpload} />} flex={1} onClick={() => onAdd(newMedia, currentAudio)}>Upload Audio</Button>
				)}
			</Center>
		</Center>
	)
}

export default AudioChecker
